var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.638672 33.7002H33.6387V0.700195H0.638672V33.7002Z",
    fill: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_27357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6387 0.700195H0.638672V33.7002H33.6387V0.700195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_27357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0137 19.3252C13.0137 20.4298 13.9091 21.3252 15.0137 21.3252H19.2637C20.3682 21.3252 21.2637 20.4298 21.2637 19.3252V15.0752C21.2637 13.9706 20.3682 13.0752 19.2637 13.0752H15.0137C13.9091 13.0752 13.0137 13.9706 13.0137 15.0752V19.3252Z",
    fill: "#666666"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1387 31.1221C17.5489 31.1221 17.9424 30.9591 18.2325 30.669C18.5226 30.3789 18.6855 29.9854 18.6855 29.5752C18.6855 29.165 18.5226 28.7715 18.2325 28.4814C17.9424 28.1913 17.5489 28.0283 17.1387 28.0283C16.7284 28.0283 16.3349 28.1913 16.0449 28.4814C15.7548 28.7715 15.5918 29.165 15.5918 29.5752C15.5918 29.9854 15.7548 30.3789 16.0449 30.669C16.3349 30.9591 16.7284 31.1221 17.1387 31.1221Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0137 31.1221C13.4239 31.1221 13.8174 30.9591 14.1075 30.669C14.3976 30.3789 14.5605 29.9854 14.5605 29.5752C14.5605 29.165 14.3976 28.7715 14.1075 28.4814C13.8174 28.1913 13.4239 28.0283 13.0137 28.0283C12.6034 28.0283 12.2099 28.1913 11.9199 28.4814C11.6298 28.7715 11.4668 29.165 11.4668 29.5752C11.4668 29.9854 11.6298 30.3789 11.9199 30.669C12.2099 30.9591 12.6034 31.1221 13.0137 31.1221Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2637 31.1221C21.6739 31.1221 22.0674 30.9591 22.3575 30.669C22.6476 30.3789 22.8105 29.9854 22.8105 29.5752C22.8105 29.165 22.6476 28.7715 22.3575 28.4814C22.0674 28.1913 21.6739 28.0283 21.2637 28.0283C20.8534 28.0283 20.4599 28.1913 20.1699 28.4814C19.8798 28.7715 19.7168 29.165 19.7168 29.5752C19.7168 29.9854 19.8798 30.3789 20.1699 30.669C20.4599 30.9591 20.8534 31.1221 21.2637 31.1221Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowDots);
export default __webpack_public_path__ + "static/media/show-dots.99336cf844dfa0d6354d4d8892f93a4b.svg";
export { ForwardRef as ReactComponent };